import { render, staticRenderFns } from "./SwitchLanguage.vue?vue&type=template&id=02ae31e4&scoped=true&"
import script from "./SwitchLanguage.vue?vue&type=script&lang=js&"
export * from "./SwitchLanguage.vue?vue&type=script&lang=js&"
import style0 from "./SwitchLanguage.vue?vue&type=style&index=0&id=02ae31e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ae31e4",
  null
  
)

export default component.exports